<template>
    <div></div>
</template>

<script>
// import $ from "jquery";
// import _ from "lodash";
import { subscribe, unSubscribe } from "../../../service/Notify";

export default {
    data() {
        return {
            medico_token: null,
            anamnese_param : null,
        };
    },

    props: ["atendimento", "id_anamnese"],

    methods: {
        show(anamnese = null) {
            this.anamnese_param = anamnese;

            this.login_medico(res => {
                if (res && res.url) {
                    window.open(res.url, "_blank").focus();
                }
            });
        },

        login_medico(callback) {
            this.$util.atualizar(this, {
                service: "memed",
                func: "login_medico",
                dados: {
                    id_atendimento: this.atendimento.id_atendimento,
                    id_anamnese: this.id_anamnese ? this.id_anamnese : this.anamnese_param,
                },
                toast: false,
                callback: res => {
                    if (res && res.msg) {
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: res.msg,
                            life: 3000
                        });
                    }
                    if (callback) {
                        callback(res);
                    }
                }
            });
        }
    },

    mounted() {
        this.canal =
            this.$store.state.dominio +
            "-" +
            this.id_anamnese +
            "-integracao-memed";

        subscribe(this.canal, "refresh", () => {
            this.$emit("refresh");
        });
    },
    beforeDestroy() {
        unSubscribe(this.canal, "refresh");
    }
};
</script>
